import { useId } from 'react'
import { Search } from 'lucide-react'
import { cn } from '@/lib/utils'

export default function FilterSearch({
  value,
  onChange,
  placeholder,
  label = 'Search',
  className,
}: {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  label?: string
  className?: string
}) {
  const id = useId()
  return (
    <div className={cn('flex w-60 flex-col gap-1.5 max-lg:w-full', className)}>
      <label htmlFor={id} className="text-[13px] font-semibold text-muted-foreground">
        {label}
      </label>
      <div className="relative">
        <Search className="absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-muted-foreground" aria-hidden />
        <input
          id={id}
          type="search"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          className="h-9 w-full rounded-md border border-input bg-card py-2 pr-3 pl-9 text-sm placeholder:text-muted-foreground focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-ring max-sm:h-11"
        />
      </div>
    </div>
  )
}
